import { useMutation } from '@tanstack/vue-query'
import { useStripeApi } from './use-stripe'

export function useCreateCheckoutSession() {
  const { createCheckoutSession } = useStripeApi()

  return useMutation({
    mutationFn: ({ priceId, metadata }) =>
      createCheckoutSession({ priceId, metadata }),
    onError: async (error) => {
      console.log('error', error)
    },
  })
}

export function useCreatePortalSession() {
  const { createPortalSession } = useStripeApi()

  return useMutation({
    mutationFn: () => createPortalSession(),
    onError: async (error) => {
      console.log('error', error)
    },
  })
}
